import {ItemsTileItem} from './ItemsTileItem/ItemsTileItem';
import {ItemsTile} from './ItemsTile';

export class ItemsTilesService {

  private tiles = new Map<string, ItemsTile>();
  private itemsWithTiles = new Map<string, { item: ItemsTileItem, itemsTiles: Array<ItemsTile> }>();

  constructor() {
  }

  public setItem(item) {
    const itemsTiles = this.generateTilesForItem(item);
    this.itemsWithTiles.set(item.getId(), {item, itemsTiles});

    for (const itemsTile of itemsTiles) {
      itemsTile.addItem(item);
    }
  }

  public deleteItem(id) {
    const itemWithTiles = this.itemsWithTiles.get(id);
    if (itemWithTiles !== undefined) {
      const itemsTiles = itemWithTiles.itemsTiles;
      this.itemsWithTiles.delete(id);

      for (const itemsTile of itemsTiles) {
        itemsTile.deleteItem(id);
      }
    }
  }

  public hasItem(id): boolean {
    return this.itemsWithTiles.has(id);
  }

  public getItem(id): ItemsTileItem {
    const itemWithTiles = this.itemsWithTiles.get(id);
    if (itemWithTiles) {
      return itemWithTiles.item;
    }
    return undefined;
  }

  public hasTile(x, y) {
    const tileKey = ItemsTile.generateKey(x, y);
    return this.tiles.has(tileKey);
  }

  public getTile(x, y) {
    const tileKey = ItemsTile.generateKey(x, y);
    return this.tiles.get(tileKey);
  }

  public getTiles(): IterableIterator<ItemsTile> {
    return this.tiles.values();
  }

  public getTilesCount() {
    return this.tiles.size;
  }

  public getTilesForItem(id): IterableIterator<ItemsTile> {
    if (this.itemsWithTiles.has(id)) {
      return this.itemsWithTiles.get(id).itemsTiles.values();
    }
    return undefined;
  }

  private generateTilesForItem(item): Array<ItemsTile> {
    const itemsTiles = [];

    const tiles = item.calculateTiles();
    for (const [tileKey, tileXY] of tiles) {
      const itemsTile = this.getOrCreateTile(tileXY, tileKey);
      itemsTiles.push(itemsTile);
    }

    return itemsTiles;
  }

  private getOrCreateTile(tileXY, tileKey) {
    //console.log('[ITEMS CANVAS] getOrCreateTile', tileXY, tileKey);
    if (this.tiles.has(tileKey)) {
      //console.log('[ITEMS CANVAS] get', tileXY, tileKey);
      return this.tiles.get(tileKey);
    }

    const itemsTile = ItemsTile.fromXY(tileXY.x, tileXY.y);
    this.tiles.set(tileKey, itemsTile);
    //console.log('[ITEMS CANVAS] create', tileXY, tileKey);
    return  itemsTile;
  }

}
